// extracted by mini-css-extract-plugin
export default {"page":"App_page__5vKaD","container":"App_container__Rt8T2"};